import { render } from "./CanceledOrderError.vue?vue&type=template&id=2a6920d6"
import script from "./CanceledOrderError.vue?vue&type=script&lang=js"
export * from "./CanceledOrderError.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__